import { movies } from "@/mocks/movies";
import { news } from "@/mocks/news";
import { specials } from "@/mocks/specials";
import type { Movie, MediaType } from "@/types/content";

export const allMovies = movies as Movie[];
export const allNews = news;
export const allSpecials = specials;

export function getMovieById(id: string | undefined): Movie | undefined {
  if (!id) return undefined;
  return allMovies.find((m) => m.id === id);
}

export function getNewsById(id: string | undefined) {
  if (!id) return undefined;
  return allNews.find((n) => n.id === id);
}

export function getMoviesByType(type: string): Movie[] {
  if (type === "movie" || type === "tv") {
    return allMovies.filter((m) => m.type === (type as MediaType));
  }
  return [...allMovies];
}

export function getTypeLabel(type: string): string {
  if (type === "movie") return "电影";
  if (type === "tv") return "电视剧";
  return "全部影视";
}

export function sortByPopularity(list: Movie[]): Movie[] {
  return [...list].sort((a, b) => b.popularity - a.popularity);
}

export function getRelatedMovies(movie: Movie, limit = 4): Movie[] {
  const scored = allMovies
    .filter((m) => m.id !== movie.id)
    .map((m) => {
      let score = 0;
      if (m.type === movie.type) score += 3;
      if (m.director === movie.director) score += 4;
      score += m.genres.filter((g) => movie.genres.includes(g)).length * 2;
      return { movie: m, score };
    })
    .sort((a, b) => b.score - a.score || b.movie.popularity - a.movie.popularity);
  return scored.slice(0, limit).map((s) => s.movie);
}

export function searchMovies(keyword: string): Movie[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [...allMovies];
  return allMovies.filter(
    (m) =>
      m.title.toLowerCase().includes(kw) ||
      m.director.toLowerCase().includes(kw) ||
      m.genres.some((g) => g.toLowerCase().includes(kw)) ||
      m.actors.some((a) => a.toLowerCase().includes(kw)) ||
      m.summary.toLowerCase().includes(kw),
  );
}

export function searchNews(keyword: string) {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [...allNews];
  return allNews.filter(
    (n) =>
      n.title.toLowerCase().includes(kw) ||
      n.summary.toLowerCase().includes(kw) ||
      n.category.toLowerCase().includes(kw),
  );
}

export function getRelatedNews(currentId: string, limit = 3) {
  return allNews.filter((n) => n.id !== currentId).slice(0, limit);
}